<template>
<div
      class="clients-area overflow-hidden default-padding bg-gradient text-light"
      id="indicadores"
    >
      <div class="container">
        <div class="client-items">
          <div class="row align-center">
            <div class="col-lg-6 info">
              <h5>
                Indicadores Previsionales <span id="fechaIndicador">{{fechaIndicador}}</span>
              </h5>
              <h2>Encuentra los indicadores que necesites aquí!</h2>
              <p>Para Cotizaciones a Pagar en <span id="cotAPagar">{{cotAPagar}}</span></p>
              <router-link to="/indicadores" class="btn circle btn-md btn-light border"><i class="fas fa-angle-right"></i> Ver Indicadores</router-link>
              <!--<a
                class="btn circle btn-md btn-light border"
                href="indicadores.html"
                ><i class="fas fa-angle-right"></i></a
              >-->
            </div>
            <div class="col-lg-5 offset-lg-1">
              <!--  -->
              <div><h1>Valores</h1></div>
              <div class="clients-carousel owl-carousel owl-theme mb-2">
                <div class="item">
                  <div class="row"><div class="col-lg-12">UF Actual</div></div>
                  <div class="row">
                    <div class="col-lg-12" id="UFactual">{{previred.UFactual}}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="row">
                    <div class="col-lg-12">UF Anterior</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12" id="UFanterior">{{previred.UFanterior}}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="row"><div class="col-lg-12">UTM</div></div>
                  <div class="row"><div class="col-lg-12" id="UTM">{{previred.UTM}}</div></div>
                </div>
                <div class="item">
                  <div class="row"><div class="col-lg-12">UTA</div></div>
                  <div class="row"><div class="col-lg-12" id="UTA">{{previred.UTA}}</div></div>
                </div>
                <div class="item">
                  <div class="row"><div class="col-lg-12">Dolar</div></div>
                  <div class="row"><div class="col-lg-12" id="USD">{{monedas.dolar}}</div></div>
                </div>
                <div class="item">
                  <div class="row"><div class="col-lg-12">Euro</div></div>
                  <div class="row"><div class="col-lg-12" id="EUR">{{monedas.euro}}</div></div>
                </div>
              </div>
              <div><h1>AFP</h1></div>
              <div class="clients-carousel owl-carousel owl-theme mb-2">
                <div class="item">
                  <div class="row"><div class="col-lg-12">Capital</div></div>
                  <div class="row">
                    <div class="col-lg-4">Dep</div>
                    <div class="col-lg-8" id="DTasaAFPCa">{{previred.DTasaAFPCa}}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">Ind</div>
                    <div class="col-lg-8" id="ITasaAFPCa">{{previred.ITasaAFPCa}}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="row"><div class="col-lg-12">Cuprum</div></div>
                  <div class="row">
                    <div class="col-lg-4">Dep</div>
                    <div class="col-lg-8" id="DTasaAFPCu">{{previred.DTasaAFPCu}}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">Ind</div>
                    <div class="col-lg-8" id="ITasaAFPCu">{{previred.ITasaAFPCu}}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="row"><div class="col-lg-12">Habitat</div></div>
                  <div class="row">
                    <div class="col-lg-4">Dep</div>
                    <div class="col-lg-8" id="DTasaAFPH">{{previred.DTasaAFPH}}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">Ind</div>
                    <div class="col-lg-8" id="ITasaAFPH">{{previred.ITasaAFPH}}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="row"><div class="col-lg-12">PlanVital</div></div>
                  <div class="row">
                    <div class="col-lg-4">Dep</div>
                    <div class="col-lg-8" id="DTasaAFPPV">{{previred.DTasaAFPPV}}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">Ind</div>
                    <div class="col-lg-8" id="ITasaAFPPV">{{previred.ITasaAFPPV}}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="row"><div class="col-lg-12">Provida</div></div>
                  <div class="row">
                    <div class="col-lg-4">Dep</div>
                    <div class="col-lg-8" id="DTasaAFPP">{{previred.DTasaAFPP}}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">Ind</div>
                    <div class="col-lg-8" id="ITasaAFPP">{{previred.ITasaAFPP}}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="row"><div class="col-lg-12">Modelo</div></div>
                  <div class="row">
                    <div class="col-lg-4">Dep</div>
                    <div class="col-lg-8" id="DTasaAFPM">{{previred.DTasaAFPM}}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">Ind</div>
                    <div class="col-lg-8" id="ITasaAFPM">{{previred.ITasaAFPM}}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="row"><div class="col-lg-12">Uno</div></div>
                  <div class="row">
                    <div class="col-lg-4">Dep</div>
                    <div class="col-lg-8" id="DTasaAFPU">{{previred.DTasaAFPU}}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">Ind</div>
                    <div class="col-lg-8" id="ITasaAFPU">{{previred.ITasaAFPU}}%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>


<script>

    import axios from "axios"
    import cons from '@/utils/const'


    //var numeral = require("numeral");

    export default {
        name: "BannerIndicadores",
        data () {
            return {
              number: {
                decimal: ',',
                separator: '.',
                prefix: '$',
                suffix: ' ',
                precision: 2,
                masked: false /* doesn't work with directive */
              },
              fechaIndicador: "",
              cotAPagar: "",
              monedas: {
                euro: 0,
                dolar: 0,
              },
              indicadores: {
                UFactual: 0,
                UFanterior: 0
              },
              previred: {
                "UFactual": "-",
                "UFanterior": "-",
                "UTM": "-",
                "UTA": "-",
                "DTasaAFPCa": "-",
                "ITasaAFPCa": "-",
                "DTasaAFPCu": "-",
                "ITasaAFPCu": "-",
                "DTasaAFPH": "-",
                "ITasaAFPH": "-",
                "DTasaAFPPV": "-",
                "ITasaAFPPV": "-",
                "DTasaAFPP": "-",
                "ITasaAFPP": "-",
                "DTasaAFPM": "-",
                "ITasaAFPM": "-",
                "DTasaAFPU": "-",
                "ITasaAFPU": "-"
              }
            }
        },
        components: {},
        beforeMount() {
          this.obtenerMoneda("USD")
          this.obtenerMoneda("EUR")
          this.obtenerIndicadores()
        },
        methods: {
          obtenerIndicadores: function(){
            var d = new Date();
            var months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septimbre", "Octubre", "Novimbre", "Dicimbre"];

            //var fechaTitulo = ""
            var fechaApagar = ""
            var periodo = ""

            if(d.getDate()<20){
                if(d.getMonth()<10){
                    periodo = "0"+d.getMonth()+""+d.getFullYear()
                }
                else{
                    periodo = d.getMonth()+""+d.getFullYear()
                }
                //fechaTitulo = months[d.getMonth()] + " " + d.getFullYear()
                fechaApagar = months[d.getMonth()] + " " + d.getFullYear()
            }
            else{
                if(d.getMonth() == 0){
                    periodo = "01"+d.getFullYear()
                    //fechaTitulo = months[0] + " " + d.getFullYear()
                    //fechaApagar = months[0] + " " + d.getFullYear()+1
                }
                else{
                    //fechaTitulo = months[d.getMonth()] + " " + d.getFullYear()
                    if(d.getMonth()<10){
                        periodo = "0"+(d.getMonth()+1)+""+d.getFullYear()
                    }
                    else{

                        periodo = (d.getMonth()+1)+""+d.getFullYear()                     
                    }
                }
                
                fechaApagar = months[d.getMonth()+1] + " " + d.getFullYear()

                this.fechaIndicador = months[d.getMonth()] + " " + d.getFullYear();
                this.cotAPagar = fechaApagar + " (Remuneraciones "+months[d.getMonth()] + " " + d.getFullYear() + ")"
            }
            var url = `${cons.gaelApi}/previred/${periodo}`
            console.log(url)
            axios({
                method: "GET", 
                "url": url,
            }).then(result => {
                console.log(result)
                //this.previred = result.data

                //this.indicadores.UFactual = result.data.UFValPeriodo.replace(",",".")
                //this.indicadores.UFanterior = result.data.UFValPeriodoAnt.replace(",",".")

                this.previred.UFactual = " $" + this.format(result.data.UFValPeriodo.replace(",","."),2) 
                this.previred.UFanterior = " $" + this.format(result.data.UFValPeriodoAnt.replace(",","."),2)
                this.previred.UTM = " $" + this.format(result.data.UTMVal) 
                this.previred.UTA = " $" + this.format(result.data.UTAVal)
                this.previred.DTasaAFPCa = (result.data.AFPCapitalTasaDepTrab)+"%"
                this.previred.ITasaAFPCa = (result.data.AFPCapitalTasaInd)+"%"
                this.previred.DTasaAFPCu = (result.data.AFPCuprumTasaDepTrab)+"%"
                this.previred.ITasaAFPCu = (result.data.AFPCuprumTasaInd)+"%"
                this.previred.DTasaAFPH = (result.data.AFPHabitatTasaDepTrab)+"%"
                this.previred.ITasaAFPH = (result.data.AFPHabitatTasaInd)+"%"
                this.previred.DTasaAFPPV = (result.data.AFPPlanVitalTasaDepTrab)+"%"
                this.previred.ITasaAFPPV = (result.data.AFPPlanVitalTasaInd)+"%"
                this.previred.DTasaAFPP = (result.data.AFPProVidaTasaDepTrab)+"%"
                this.previred.ITasaAFPP = (result.data.AFPProVidaTasaInd)+"%"
                this.previred.DTasaAFPM = (result.data.AFPModeloTasaDepTrab)+"%"
                this.previred.ITasaAFPM = (result.data.AFPModeloTasaInd)+"%"
                this.previred.DTasaAFPU = (result.data.AFPUnoTasaDepTrab)+"%"
                this.previred.ITasaAFPU = (result.data.AFPUnoTasaInd)+"%"

                
                
            }, error => {
              console.log(error)
                
            })
            .finally(() => {
                
            });
          },
          obtenerMoneda: function(moneda){
              var url = `${cons.gaelApi}/monedas/${moneda}`
              
              axios({
                  method: "GET", 
                  "url": url,
              }).then(result => {
                  console.log(result.data.Valor)
                  if(moneda == "USD"){
                    this.monedas.euro = " $"+(result.data.Valor)
                  } else if(moneda == "EUR"){
                    this.monedas.dolar = " $"+(result.data.Valor)
                  }
                  
              }, error => {
                console.log(error)
                  
              })
              .finally(() => {
                  
              });
          },


          format: function(amount, decimals,separadorMiles,separadorDecimal) {
            var sepMiles = separadorMiles;
            var sepDecimal = separadorDecimal;
            if(typeof separadorMiles === "undefined"){
                sepMiles = ".";
            }
            if(typeof separadorDecimal === "undefined"){
                sepDecimal = ",";
            }
            amount += ''; // por si pasan un numero en vez de un string
            /* eslint-disable-next-line */
            amount = parseFloat(amount.replace(/[^0-9\.]/g, '')); // elimino cualquier cosa que no sea numero o punto
            decimals = decimals || 0; // por si la variable no fue fue pasada
            // si no es un numero o es igual a cero retorno el mismo cero
            if (isNaN(amount) || amount === 0) 
                return parseFloat(0).toFixed(decimals);
            // si es mayor o menor que cero retorno el valor formateado como numero
            amount = '' + amount.toFixed(decimals);
            var amount_parts = amount.split(sepMiles),
                regexp = /(\d+)(\d{3})/;
            while (regexp.test(amount_parts[0]))
                amount_parts[0] = amount_parts[0].replace(regexp, '$1' + sepMiles + '$2');
            return amount_parts.join(sepDecimal);
          }
        }
    };
</script>